export default __webpack_public_path__ + "static/media/flag-otan.e7dab289.svg";